import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const maxMind = defineConnector({
  identifier: "maxMind",
  name: "MaxMind",
  tagLine: "IP geolocation web services",
  logo,
  protocol: "http",
  tags: ["data", "security"],
  defaultUrlPattern: () => "https://(geoip|sandbox)\\.maxmind\\.com/.*",
  auth: (app) =>
    basicAuth({
      username: app.config.accountId,
      password: app.secret.licenseKey,
    }),
  steps: [
    {
      title: "Get your account ID and license key",
      items: [
        {
          kind: "markdown",
          content:
            "In the [MaxMind account portal](https://www.maxmind.com/), create or copy a license key and note your account ID. MaxMind web services use HTTP Basic auth with account ID as the username and license key as the password.",
        },
      ],
    },
    {
      title: "Enter your MaxMind credentials",
      items: [
        {
          kind: "input",
          label: "Account ID",
          required: true,
          target: { kind: "configuration", field: "accountId" },
        },
        {
          kind: "input",
          label: "License key",
          required: true,
          target: { kind: "secrets", field: "licenseKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://geoip.maxmind.com/geoip/v2.1/country/me",
  },
});
